module.exports = __webpack_public_path__ + "static/media/fin_up3.07fb68a2.png";